import FactoryComponents from '../../../../../../factory/components/FactoryComponents.js';
import moment from "moment";
const root = {}
export default root
root.name = 'ProcessWorkPermitSelectPopup';
root.props = {

}

root.data = {
    isChange: true,
    activeIndex: 0,
    openWorkCodePopup: true,
    activeWorkCode: '3',
    workTabs: [
        {
            certificateTypeName: '临时用电',
            certificateTypeId: '3',
            selectData: []
        },
        {
            certificateTypeName: '动火作业',
            certificateTypeId: '4',
            selectData: []
        },
        {
            certificateTypeName: '受限空间',
            certificateTypeId: '7',
            selectData: []
        },
        {
            certificateTypeName: '盲板抽堵',
            certificateTypeId: '8',
            selectData: []
        },
        {
            certificateTypeName: '高处作业',
            certificateTypeId: '9',
            selectData: []
        },
        {
            certificateTypeName: '吊装作业',
            certificateTypeId: '10',
            selectData: []
        },
        {
            certificateTypeName: '短路作业',
            certificateTypeId: '11',
            selectData: []
        },
        {
            certificateTypeName: '动土作业',
            certificateTypeId: '12',
            selectData: []
        },
    ],
    planTime: '',
    workPermitListParams: {
        //"status": 6,
        "certificateTypeId": 3,//类型
        "planStartTime": "",
        "planEndTime": ""
    },
    workPermitList: [],
    currentPage: 1,
    total: 0,
    selectedWorkPermitMap: {},

}

root.watch = {
    planTime(newValue, oldValue) {
        if (newValue) {
            this.workPermitListParams.planStartTime = newValue[0]
            this.workPermitListParams.planEndTime = newValue[1]
        } else {
            this.workPermitListParams.planStartTime = ''
            this.workPermitListParams.planEndTime = ''
        }

    }
},

    root.methods = {
        //关闭弹窗之前
        handleClose: function (done) {
            this.$emit('closeWorkCodePopup', true)
            done()
        },
        //确定按钮
        comfirmButton: function () {
            let selectData = []
            Object.keys(this.selectedWorkPermitMap).forEach(no => {
                const item = this.selectedWorkPermitMap[no]
                selectData.push({ no: item.no, name: item.name })
            })
            this.$emit('setWorkPermitData', [{ selectData }])
        },
        //取消按钮
        cancelButton: function () {
            this.$emit('closeWorkCodePopup', true)
        },
        //搜索
        toSearch: function () {
            this.workPermitList = []
            this.getWorkPermitList()
        },
        //初始化已选作业票
        initSelectedWorkPermitMap: function () {
            this.selectedWorkPermitMap = {}
            const preWorkInfo = this.$store.state.preWorkInfo.preWorkInfo || []
            preWorkInfo.forEach(item => {
                if (item && item.no) {
                    this.$set(this.selectedWorkPermitMap, item.no, item)
                }
            })
        },
        //获取列表数据
        getWorkPermitList: function () {
            let _this = this
            this.isChange = true
            this.componentsMoudel.startPost('/workPermit/list_all', this.workPermitListParams, true).then(res => {
                if (res.result == 'success') {
                    _this.workPermitList = res.body.data || []
                    this.$nextTick(() => {
                        const selectedRows = _this.workPermitList.filter(item => item && _this.selectedWorkPermitMap[item.no])
                        _this.workTabs[_this.activeIndex].selectData = selectedRows
                        selectedRows.forEach(row => {
                            _this.$refs.myMultipleTable[_this.activeIndex].toggleRowSelection(row, true)
                        })
                        this.$nextTick(() => {
                            _this.isChange = false
                        })
                    })

                    this.total = res.body.cum || 0
                } else {
                    this.total = 0
                    this.isChange = false
                }

            }).catch(() => {
                this.isChange = false
                return
            });

        },
        handleSizeChange(val) {
           // console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
           // console.log(`当前页: ${val}`);
        },
        handleTabClick: function (tab, event) {
            this.isChange = true
            this.activeIndex = tab.index
            this.workPermitListParams.certificateTypeId = Number(this.workTabs[tab.index].certificateTypeId)
            this.workPermitList = []
            this.getWorkPermitList()
        },
        //多选框
        handleSelectionChange: function (val) {
            if (this.isChange) {
                return
            }
            this.workPermitList.forEach(item => {
                if (item && item.no) {
                    this.$delete(this.selectedWorkPermitMap, item.no)
                }
            })
            val.forEach(item => {
                if (item && item.no) {
                    this.$set(this.selectedWorkPermitMap, item.no, item)
                }
            })
            this.workTabs[this.activeIndex].selectData = val
        },
        //涉及的其他特殊作业及编号选择弹窗-清空按钮
        toClickWorkPermitListParamsTime: function () {
            this.planTime = null
            this.workPermitListParams.planStartTime = ''
            this.workPermitListParams.planEndTime = ''
        },

    }

root.mounted = function () {
    this.initSelectedWorkPermitMap()
    this.getWorkPermitList()
}

FactoryComponents.initComponent(root);
